export const Controller = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1802_2829)">
        <path
          d="M18 17.5C20.5 21 24.4487 18.4151 23.5 15C22.0754 9.87113 21.3002 7.01556 20.8969 5.50793C20.6598 4.62136 19.8562 4 18.9385 4H6.06161C5.14388 4 4.34406 4.62481 4.12092 5.515C3.28156 8.86349 2.53266 11.8016 1.64421 15C0.695562 18.4151 4.64421 21 7.14421 17.5M18.5001 8.5L18.5112 8.51M16.99 7L17.0012 7.01M16.99 10L17.0012 10.01M15.5001 8.5L15.5112 8.51M7.50004 7V10M6.00004 8.5H9.00004M10.5 14C10.5 15.1046 9.60461 16 8.50004 16C7.39547 16 6.50004 15.1046 6.50004 14C6.50004 12.8954 7.39547 12 8.50004 12C9.60461 12 10.5 12.8954 10.5 14ZM18.5 14C18.5 15.1046 17.6046 16 16.5 16C15.3955 16 14.5 15.1046 14.5 14C14.5 12.8954 15.3955 12 16.5 12C17.6046 12 18.5 12.8954 18.5 14Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1802_2829">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
